import React,{useState} from 'react'
import {Link,useNavigate} from 'react-router-dom'
import icon from '../../assets/icon_light.svg'
import ButtonPrimaryWithIcon from '../Buttons/ButtonPrimaryWithIcon'

/**
 * PublicNav — shared navigation for all public pages:
 * Landing, Login, Verify, Pricing, Privacy.
 * Replaces the diverged GuestBar and Logobar components.
 */
export default function PublicNav({minimal=false}) {
    const navigate=useNavigate()
    const [menuOpen,setMenuOpen]=useState(false)

    return (
        <nav className="flex items-center justify-between w-full px-4 py-3 border-b border-gray-100 bg-light/95 backdrop-blur-sm sticky top-0 z-40" aria-label="Main navigation">
            {/* Logo */}
            <Link to='/' aria-label="Flowsage home" className="flex-shrink-0">
                <img src={icon} alt="Flowsage" className="h-8 w-auto" />
            </Link>

            {/* Desktop links */}
            {!minimal&&(
                <div className="hidden md:flex items-center gap-6">
                    <Link to='/pricing' className="text-sm font-medium text-dark-400 hover:text-primary transition-colors">Pricing</Link>
                    <Link to='/login' className="text-sm font-medium text-dark-400 hover:text-primary transition-colors">Login</Link>
                    <ButtonPrimaryWithIcon
                        onClick={()=>navigate('/login')}
                        icon="arrow-right-short"
                        className="!py-1.5 !px-4 !text-sm !w-auto"
                    >
                        Get started free
                    </ButtonPrimaryWithIcon>
                </div>
            )}

            {/* Mobile hamburger */}
            {!minimal&&(
                <button
                    onClick={()=>setMenuOpen(o=>!o)}
                    className="md:hidden p-2 rounded-lg hover:bg-gray-100 transition-colors"
                    aria-label={menuOpen?'Close menu':'Open menu'}
                    aria-expanded={menuOpen}
                >
                    <div className="w-5 h-0.5 bg-dark mb-1 transition-all" style={{transform: menuOpen?'rotate(45deg) translateY(6px)':'none'}} />
                    <div className="w-5 h-0.5 bg-dark mb-1 transition-all" style={{opacity: menuOpen?0:1}} />
                    <div className="w-5 h-0.5 bg-dark transition-all" style={{transform: menuOpen?'rotate(-45deg) translateY(-6px)':'none'}} />
                </button>
            )}

            {/* Mobile menu dropdown */}
            {!minimal&&menuOpen&&(
                <div className="absolute top-full left-0 right-0 bg-white border-b border-gray-200 shadow-lg md:hidden z-50">
                    <div className="flex flex-col gap-1 p-4">
                        <Link
                            to='/pricing'
                            onClick={()=>setMenuOpen(false)}
                            className="px-4 py-3 text-sm font-medium text-dark rounded-lg hover:bg-gray-50 transition-colors"
                        >
                            Pricing
                        </Link>
                        <Link
                            to='/login'
                            onClick={()=>setMenuOpen(false)}
                            className="px-4 py-3 text-sm font-medium text-dark rounded-lg hover:bg-gray-50 transition-colors"
                        >
                            Login
                        </Link>
                        <ButtonPrimaryWithIcon
                            onClick={()=>{setMenuOpen(false);navigate('/login')}}
                            icon="arrow-right-short"
                            className="!w-full !py-2 !text-sm mt-2"
                        >
                            Get started free
                        </ButtonPrimaryWithIcon>
                    </div>
                </div>
            )}
        </nav>
    )
}
